import { createReducer } from 'utils/reduxUtils';
import set from 'lodash/fp/set';
import flow from 'lodash/fp/flow';
import * as supportStatuses from './constants/supportStatuses';
import {
  CLEAR_SUPPORT_SEARCH,
  FETCH_SUPPORT_ARTICLES_FAILURE,
  FETCH_SUPPORT_ARTICLES_REQUEST,
  FETCH_SUPPORT_ARTICLES_SUCCESS,
  FETCH_SUPPORT_CATEGORIES_FAILURE,
  FETCH_SUPPORT_CATEGORIES_REQUEST,
  FETCH_SUPPORT_CATEGORIES_SUCCESS,
  FETCH_SUPPORT_SEARCH_FAILURE,
  FETCH_SUPPORT_SEARCH_REQUEST,
  FETCH_SUPPORT_SEARCH_SUCCESS,
  FETCH_SUPPORT_TAGS_FAILURE,
  FETCH_SUPPORT_TAGS_REQUEST,
  FETCH_SUPPORT_TAGS_SUCCESS,
} from './actionsTypes';

import initialState from './initialState';

const reducerToActionTypeMap = {
  [FETCH_SUPPORT_CATEGORIES_REQUEST]: set('categoriesStatus', supportStatuses.LOADING),
  [FETCH_SUPPORT_CATEGORIES_SUCCESS]: (state, { categories } = {}) =>
    flow(
      set('categoriesStatus', supportStatuses.SUCCESS),
      set('fetchedCategories', categories)
    )(state),
  [FETCH_SUPPORT_CATEGORIES_FAILURE]: set('categoriesStatus', supportStatuses.ERROR),

  [FETCH_SUPPORT_ARTICLES_REQUEST]: set('articlesStatus', supportStatuses.LOADING),
  [FETCH_SUPPORT_ARTICLES_SUCCESS]: (state, { articles } = {}) =>
    flow(set('articlesStatus', supportStatuses.SUCCESS), set('fetchedArticles', articles))(state),
  [FETCH_SUPPORT_ARTICLES_FAILURE]: set('articlesStatus', supportStatuses.ERROR),

  [FETCH_SUPPORT_SEARCH_REQUEST]: set('searchStatus', supportStatuses.LOADING),
  [FETCH_SUPPORT_SEARCH_SUCCESS]: (state, { search } = {}) =>
    flow(set('searchStatus', supportStatuses.SUCCESS), set('fetchedSearch', search))(state),
  [FETCH_SUPPORT_SEARCH_FAILURE]: set('searchStatus', supportStatuses.ERROR),
  [CLEAR_SUPPORT_SEARCH]: flow(set('searchStatus', supportStatuses.IDLE), set('fetchedSearch', [])),

  [FETCH_SUPPORT_TAGS_REQUEST]: set('fetchedTagsStatus', supportStatuses.LOADING),
  [FETCH_SUPPORT_TAGS_SUCCESS]: (state, { fetchedTags } = {}) =>
    flow(set('fetchedTagsStatus', supportStatuses.SUCCESS), set('fetchedTags', fetchedTags))(state),
  [FETCH_SUPPORT_TAGS_FAILURE]: set('fetchedTagsStatus', supportStatuses.ERROR),
};

export default createReducer(reducerToActionTypeMap, initialState);
